import { atom } from "jotai";

import { VerifyCodeStepState } from "../types";
import {
  UpdateEmailOrPhoneProfileStepStateAtom,
  defaultUpdateEmailOrPhoneProfileStepState,
} from "./stores";

export const ProceedToVerifyCodeStepAtom = atom(
  null,
  (
    _,
    set,
    {
      email,
      phone,
    }: {
      email: string | null;
      phone: string | null;
    }
  ) => {
    const nextStep: VerifyCodeStepState = {
      step: "VerifyCode",
      email,
      phone,
      backStep: "Initial",
    };
    set(UpdateEmailOrPhoneProfileStepStateAtom, nextStep);
  }
);

export const GoBackToPreviousStepAtom = atom(null, (get, set) => {
  const state = get(UpdateEmailOrPhoneProfileStepStateAtom);
  const backStep = state.backStep;
  if (backStep) {
    switch (backStep) {
      case "Initial":
        set(
          UpdateEmailOrPhoneProfileStepStateAtom,
          defaultUpdateEmailOrPhoneProfileStepState
        );
        break;
      default:
        set(
          UpdateEmailOrPhoneProfileStepStateAtom,
          defaultUpdateEmailOrPhoneProfileStepState
        );
    }
  }
});
